import { render, staticRenderFns } from "./listProductRetailerMargin.vue?vue&type=template&id=42167dae"
import script from "./listProductRetailerMargin.vue?vue&type=script&lang=js"
export * from "./listProductRetailerMargin.vue?vue&type=script&lang=js"
import style0 from "./listProductRetailerMargin.vue?vue&type=style&index=0&id=42167dae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports